export default __webpack_public_path__ + "assets/images/ad5303df6a598725ae6182f3bc8ac08e.jpg";